import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from './app.state';
import { AppSettings } from './modules/shared/model/appSettings.model';
import { addAppSettings } from './state/actions/app-settings.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  title = 'Accela CommunityView';
  embedded: boolean;
  settings: AppSettings;


  constructor(private activatedRoute: ActivatedRoute, private store: Store<AppState>){
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:keyup', ['$event'])
  private resetSessionTimer(e: Event){
    window.parent.postMessage('CommunityView:ResetSessionClock', '*');
  }

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);


    this.embedded =  urlParams.get('inLegacyUI')?.trim().toLowerCase()==='true';
    const adminFlag = urlParams.get('isAdmin')?.toUpperCase();
    const isAdmin = (adminFlag && (adminFlag === 'Y' || adminFlag === 'YES'));
    this.settings = {
      AdminMode: isAdmin,
      embedMode: urlParams.get('Embed')?.toLowerCase() === 'true' || false,
      licenseRequiredForRegistration: null,
      licenseRequiredForRegistrationSet: false
    };

    this.store.dispatch(addAppSettings(this.settings));

  }

}
